module.exports = __webpack_public_path__ + "static/media/emp_commande_cours_complete.353c8032.png";